export default __webpack_public_path__ + "static/media/h-lr-a.ca183080.png";